var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.748,
    height: 13.435,
    viewBox: "0 0 10.748 13.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit",
    d: "M6.672,15.091h9.4a.672.672,0,0,1,0,1.343h-9.4a.672.672,0,0,1,0-1.343ZM6,11.733l6.717-6.717L14.733,7.03,8.015,13.748H6Zm7.389-7.389L14.733,3l2.015,2.015L15.4,6.36Z",
    transform: "translate(-6 -3)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e72788ce376511d4962d438f35629f24.svg";
export { ForwardRef as ReactComponent };